import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import cn from 'classnames'
import { pathOr } from 'ramda'
import { generate as generateId } from 'shortid'
import { SEARCH_FILTERS_FORM, FILTER_DATES } from '../../../search/constants'
import filterChange from '../../../search/actions/filters/filterChange'
import {mapInteractGA4, pushBookMap} from '../../../../helpers/gtm'

import './slideitem.scss'

class SlideItem extends React.PureComponent {
  isMobile = false

  static propTypes = {
    className: PropTypes.string,
    item: PropTypes.objectOf(Object).isRequired,
    onSelectSliderItem: PropTypes.func.isRequired,
    onFilterChange: PropTypes.func.isRequired,
    dates: PropTypes.arrayOf(Object),
    isDestination: PropTypes.bool.isRequired,
  }

  static defaultProps = {
    className: null,
    dates: null,
  }

  constructor() {
    super()
    this.mMove = false
  }

  state = {
    toolTipClass: '',
  }

  onToolTipClick = () => {
    const { toolTipClass } = this.state
    this.setState({
      toolTipClass: toolTipClass.length > 0 ? '' : 'active-tooltip',
    })
  }

  reserveBtnHandler = (e) => {
    e.stopPropagation()
    const {
      item: {
        reserveBtnUrl,
        available,
      },
      dates,
      onFilterChange,
      isDestination,
    } = this.props

    if ((!dates || !available) && !isDestination) {
      onFilterChange('activeFilter', FILTER_DATES)
    } else {
      window.location = reserveBtnUrl
      pushBookMap();
      mapInteractGA4('hotel book');
    }
  }

  render() {
    const {
      item, className, isDestination,
    } = this.props
    const { toolTipClass } = this.state
    return (
      <div
        className={cn('slide-item', className)}
        role="presentation"
        data-cs-hotelid={item.id}
      >
        <div className="slide-item__image">
          <img {...item?.firstImage} alt={pathOr('', ['title'])(item?.firstImage)} />
        </div>

        <div className="slide-item__content">
          <div className="slide-item__line slide-item__line--top">
            <div className="slide-item__col">
              {isDestination ? (
                <button
                  type="button"
                  className="slide-item__title"
                  onMouseDown={() => { this.mMove = false }}
                  onMouseMove={() => { this.mMove = true }}
                  onMouseUp={() => {
                    if (!this.mMove) window.open(item.hotelLink, '_blank')
                  }}
                >
                  {item.title.length > 32 ? `${item.title.slice(0, 32)}...` : item.title}
                </button>
              ) : (
                <a
                  href={item.hotelLink}
                  rel="noopener noreferrer"
                  target="_blank"
                  className="slide-item__title"
                >
                  {item.title.length > 46 ? `${item.title.slice(0, 46)}...` : item.title}
                </a>

              )}
            </div>

            <div className="slide-item__col">
              {item.subTitle ? (
                <div
                  role="button"
                  tabIndex="0"
                  onClick={this.onToolTipClick}
                  onKeyDown={() => {}}
                  className={cn('slide-item__feature-title', toolTipClass)}
                >
                  {(item.subTitle.length > 40) ? (
                    `${item.subTitle.slice(0, 40)} ...`)
                    : item.subTitle}
                  {(item.subTitle.length > 40) ? (
                    <span className="search-item__tooltip">
                      {item.subTitle}
                    </span>) : null}
                </div>) : null}

              <div className="slide-item__feture-images">
                {(item.featureImages && item.featureImages.length)
                  ? item.featureImages.map(image => (
                    <span className="ico" key={generateId()}>
                      <i className={image.className} />
                    </span>
                  ))
                  : null}
              </div>
            </div>
          </div>
          <div className="slide-item__line slide-item__line--bottom">
            <div className="slide-item__col">
              {'discount' in item ? (
                <div className="slide-item__discount">
                  {item.discount.price}
                </div>) : null}
              {item.subPrice ? (
                <div className="slide-item__sub-price">
                  {item.subPrice}
                </div>) : null}
              <div className="slide-item__prices">
                <span>
                  {item.from}
                </span>
                <div>
                  {item.price}
                </div>
                {item.oldPrice ? (
                  <div className="slide-item__old-price">
                    {item.oldPrice}
                  </div>) : null}
              </div>
            </div>
            <div className="slide-item__col btn-holder">
              {item.reserveTitle ? (
                <div className="slide-item__reserve-title">
                  {item.reserveTitle}
                </div>) : null}
              {item.reserveBtnUrl && (
                <button
                  type="button"
                  className="slide-item__reserve-btn"
                  onClick={this.reserveBtnHandler}
                >
                  {item.reserveBtn}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect((state) => {
  const { form } = state
  const dates = pathOr(null, [SEARCH_FILTERS_FORM, 'dates'], form)

  return {
    dates,
  }
}, {
  onFilterChange: filterChange,
})(SlideItem)
